/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type ComponentType, type FC, type MouseEvent } from 'react';
import { MenuGroupMinWidth } from '@jira/navigation-apps__constants/src/MenuGroupMinWidth.tsx';
import MenuGroup from '@atlaskit/menu/menu-group';
import type { ContentProps } from '@atlaskit/popup/types';
import { Box } from '@atlaskit/primitives/compiled/box';
import type { OnCloseProps } from '../../../common/types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type MoreNavMenuButtonMenuItemsProps = OnCloseProps;

export type MoreNavMenuButtonSubmenuPassThroughProps = {
	MenuItems: ComponentType<MoreNavMenuButtonMenuItemsProps>;
};

type MoreNavMenuButtonSubmenuProps = MoreNavMenuButtonSubmenuPassThroughProps & ContentProps;

const stopEventPropagation = (event: MouseEvent<HTMLDivElement>) => event.stopPropagation();

/**
 * @param MenuItems -  Wrap your menu items (e.g. a list of <LinkItem>-s) with <Section isList>, otherwise there will be a11y error about "Missing list markup" / lacking <ul<li> structure.
 */
export const MoreNavMenuButtonSubmenu: FC<MoreNavMenuButtonSubmenuProps> = ({
	MenuItems,
	onClose,
}) => (
	<Box onMouseEnter={stopEventPropagation} onMouseLeave={stopEventPropagation}>
		<MenuGroup minWidth={MenuGroupMinWidth}>
			<MenuItems onClose={onClose} />
		</MenuGroup>
	</Box>
);
